import { render } from "./ManageCategoriesView.vue?vue&type=template&id=1cbb2d56&scoped=true"
import script from "./ManageCategoriesView.vue?vue&type=script&lang=js"
export * from "./ManageCategoriesView.vue?vue&type=script&lang=js"

import "./ManageCategoriesView.vue?vue&type=style&index=0&id=1cbb2d56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbb2d56"]])

export default __exports__